"use client";

import { size, theme } from "@/config/theme";
import { SCContainerContent } from "@/utils/styledComponents";
import styled from "styled-components";
import { breakpoints } from "@/utils/breakpoint";

type SimpleContentBlockProps = {
    title: string;
    description?: string;
};

const SimpleContentBlockWithHeaderOnly = ({
    title,
    description
}: SimpleContentBlockProps) => {
    return (
        <SCWrapper theme={theme}>
            <SCContent theme={theme}>
                <div className="text-container">
                    <h2 className="text-largexlarge">{title}</h2>
                    {description && (
                        <div className="text-medium">
                            <p>{description}</p>
                        </div>
                    )}
                </div>
            </SCContent>
        </SCWrapper>
    );
};

export default SimpleContentBlockWithHeaderOnly;

const SCWrapper = styled.div`
    background-color: ${(props) => (props.theme as any)["color-white"]};
    display: flex;
    justify-content: center;
    padding: ${(props) => (props.theme as any)["spacing-lxl"]} 0;
`;

const SCContent = styled(SCContainerContent)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    ${breakpoints(
        "flex-direction",
        "",
        [{ [size.px.sxs]: "column-reverse" }],
        "max-width"
    )};

    > div {
        width: 100%;
        ${breakpoints("width", "", [{ [size.px.sxs]: "100%" }], "max-width")};
    }

    .text-container {
        .text-xlarge {
            font-size: ${(props) => (props.theme as any)["fontsize-xl"]};
            margin-bottom: ${(props) => (props.theme as any)["spacing-l"]};
        }
        .text-largexlarge {
            font-size: ${(props) => (props.theme as any)["fontsize-lxl"]};
            font-weight: 500;
            margin-bottom: ${(props) => (props.theme as any)["spacing-m"]};
        }
        .text-medium {
            font-size: ${(props) => (props.theme as any)["fontsize-m"]};
            color: ${(props) => (props.theme as any)["color-grey"]};
            margin-bottom: ${(props) => (props.theme as any)["spacing-l"]};
        }
    }
`;
